import { Box, Typography } from "@mui/material";
const Associated = ({ title }) => {
  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "var(--Spacing-spacing-48, 48px)",
        paddingLeft: "var(--Spacing-spacing-4, 4px)",
        alignItems: "center",
        gap: "var(--Spacing-spacing-8, 8px)",
        alignSelf: "stretch",
        borderRadius: "var(--Corner-radius-corner-radius-small, 8px)",
        borderBottom: "1px solid var(--Tokens-Border-Default, #D7E5F8)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          paddingRight: "var(--Spacing-spacing-8, 8px)",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "var(--Spacing-spacing-2, 2px)",
          flex: "1 0 0",
        }}
      >
        <Typography
          noWrap
          sx={{
            overflow: "hidden",
            color: "var(--Tokens-Text-Primary, #3A3A3A)",
            fontFeatureSettings: "'liga' off, 'clig' off",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",

            fontFamily: "var(--Typography-Font-Family-Heading, Inter)",
            fontSize: "var(--Font-Size-H5, 24px)",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "var(--Line-Height-H5, 32px)",
          }}
        >
          {title}
        </Typography>
      </Box>
    </Box>
  );
};

export default Associated;
